<template>
  <div class="btn-group float-right right-action video-sort">
    <a
      href="#"
      class="right-action-link text-gray"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      Sort by <i
        class="fa fa-caret-down"
        aria-hidden="true"
      />
    </a>
    <div class="dropdown-menu dropdown-menu-right">
      <a
        v-for="(item, index) in sorts"
        :key="index"
        class="dropdown-item"
        @click="sort(item.sorting)"
      >
        <i :class="`fas fa-fw ${item.icon}`" /> &nbsp;
        <span
          :class="`${sorting === item.sorting ?
            'active'
            : ''
          }`"
        >
          {{ item.label }}
        </span>
      </a>
      <a
        class="dropdown-item"
        href="#"
      >
        <i class="fas fa-fw fa-times-circle" />
        &nbsp; Close
      </a>
    </div>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify';

export default {
  data() {
    return {
      sorts: [
        {
          sorting: 'most-recent',
          label: 'Most Recent',
          icon: 'fa-clock',
        },
        {
          sorting: 'most-liked',
          label: 'Most Liked',
          icon: 'fa-thumbs-up',
        },
        {
          sorting: 'most-viewed',
          label: 'Most Viewed',
          icon: 'fa-eye',
        },
        {
          sorting: 'most-favorited',
          label: 'Most Favorited',
          icon: 'fa-star',
        },
        {
          sorting: 'most-disliked',
          label: 'Most Disliked',
          icon: 'fa-thumbs-down',
        },
        {
          sorting: 'most-commented',
          label: 'Most Commented',
          icon: 'fa-comments',
        },
        {
          sorting: 'shortest',
          label: 'Shortest',
          icon: 'fa-comments',
        },
        {
          sorting: 'longest',
          label: 'Longest',
          icon: 'fa-comments',
        },
      ],
    };
  },

  computed: {
    ...sync(['filter.sorting']),
  },

  methods: {
    sort(sorting) {
      Bus.$emit('change_sorting', sorting);
    },
  },
};
</script>

<style scoped>
.video-sort .active {
  font-weight: bold;
}
</style>
